import * as THREE from 'three'
require('three-orbitcontrols');

import printModel from '../../../3dapps/mixins/printModel';
import { initThree, scene, camera, renderer, incRenderCount, createFloor } from './initThree';
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Range from 'vux/src/components/range/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XProgress from 'vux/src/components/x-progress/index.vue'
import Box from 'vux/src/components/box/index.vue'

import loading from '@/components/loading';
import { baseURL } from '@/request/request.js';

import img1 from '../imgs/花瓶1.png';
import img2 from '../imgs/花瓶2.png';
import img3 from '../imgs/花瓶3.png';
import img4 from '../imgs/花瓶4.png';
import img5 from '../imgs/花瓶5.png';
import img6 from '../imgs/花瓶6.png';
import img7 from '../imgs/花瓶7.png';
import img8 from '../imgs/花瓶8.png';
import img9 from '../imgs/花瓶9.png';
import img10 from '../imgs/花瓶10.png';
import img11 from '../imgs/花瓶11.png';
import img12 from '../imgs/花瓶12.png';
import img13 from '../imgs/花瓶13.png';
import img14 from '../imgs/花瓶14.png';
import img15 from '../imgs/花瓶15.png';
import relief1 from '../imgs/relief01.bmp';
import relief2 from '../imgs/relief02.bmp';
import relief3 from '../imgs/relief03.bmp';
import relief4 from '../imgs/relief04.bmp';

import shareImg from '../../../assets/images/usericon2.png';

let editor;
let editor2;
let editor3;
let imgurl;










function makeImageUrl(uid, process, ext) {
return baseURL + '/makeRelief/getImage/' + uid + '/' + process + ext;
}
const sampleImageUids = [
"sample,9a15e9fd6b0a4363926446a9a18be6f3",
"sample,febbec1995c94a3f8c1e7cf3229db14a",
"sample,bd5497c92f034ffc8f1a51f030950875",
"sample,ef2a9afc345f4804b67e6750408e75cf",
"sample,cd4302e9dcfd4ffa8af56d05b24f70e0",
"sample,935c758473a94ea288f0709c813055d5",
"sample,8cbed45f48954a6d942f9548ef57041f",
"sample,54bf14eb23414ad3bb5240ab73cfbfd4",
"sample,d91bdf2db495486f833d172cb3f75ebd",
"sample,354be159fd9e4ae3a3b4e80cef38a76d",
"sample,090ccdf08584441b9d3bbc65fcdf4c9c",
"sample,7ec2b0ba10684bb49e375536bd5d1f1f",
"sample,a1caf27741f04bf1970c2a92e5472173",
"sample,e128d2beb38c45d2b3a5aecddb793a41",
"sample,a79ea760d873497b861c6e4cf623b897",
"sample,e194dc126bc649afa8aa6efe54b776b9",
"sample,dae71371b786403a9db9c9b27467bbc5",
"sample,7e46627141f445698e9069ac33088523",
"sample,fde1e6c1f8584629a171a4f0def185ea",
"sample,bd53459cb3e84aa59b59973e86d1a08e"
];

export default {
name: "papercutLamp",
mixins: [printModel],
components: {
XDialog,
range: Range, radio: Radio, Group, Cell, loading, Checker, CheckerItem, XSwitch, XProgress, Box
},
data() {
return {
quotationName: "定制花瓶",
productType: "花瓶",
landscape: true,//竖屏状态要一直为true
showLoading: false,
showVaseBottom: false,
showReliefBottom: false,
showPrint: false,
showTabList: false,
showTabList1: false,
showCurve: false,
showBottle: false,
showIrregular: false,
showOwner: true,
isShareWork: false, // 是分享作品
addCartIndex: -1,
orderIndex: -1,
cur: 0, //默认选中第一个tab
cur1: 0,
cur2: 0,
cur3: 0,
btnsListIndex1: -1,
btnsListIndex2: -1,
btnsListIndex3: -1,
btnsListIndex4: -1,
disabled: false,
isShapeIndex: 0,
isShapeIndex1: 0,
isReliefIndex: 0,
ownerName: "",
ownerImg: "",
bottleData: 0,
choiceStyle: 0,
irregularData: 0,
rotationsWayData: "1",
pointCount: 5,
pointCount1: 5,//点的默认值
pointCount2: 4,//点的默认值
percent: 0,
showBottleData: false,//第二种（直线或者弧线）
showIrregularData: false,//第三种（直线或者弧线）
showRotations: false,//旋转
showRotationsWay: false,//旋转方式
showRepeatTimes: false,//边数
showVaseScale: false,//花瓶缩放
showReliefScale: false,//浮雕缩放
showPoints1: false,//点1
showPoints2: false,//点2
showBottleCanvas: false,//显示第二种
showIrregularCanvas: false,//显示第三种画布
versionNum: 2,
noUpdateMesh: false,
showDownloads: false,
showRelief: false,
showBtnList1: true,
showBottomPop: false,
showPrintImg: true,
showdownloadImg: true,
showShareImg: true,

showPotImg: true,

showXiang: false,
showMenu: false,
userUploadImages: [],
sampleImages: sampleImageUids.map(uid => makeImageUrl(uid, 'thumb', '.jpg')),
btnsList1: [
{
isClick: false,
icon: require("../imgs/编辑.png"),
iconClick: require("../imgs/编辑（选中）.png"),
},
{
isClick: false,
icon: require("../imgs/设置.png"),
iconClick: require("../imgs/设置（选中）.png"),
},
{
isClick: false,
icon: require("../imgs/模型.png"),
iconClick: require("../imgs/模型（选中）.png"),
},
], //按钮列表
btnsList2: [
{
isClick: false,
icon: require("../imgs/美化.png"),
iconClick: require("../imgs/美化（选中）.png"),
},
],
btnsList3: [
{
isClick: false,
icon: require("../imgs/美化.png"),
iconClick: require("../imgs/美化（选中）.png"),
},
],
btnsList4: [
{
isClick: false,
icon: require("../../../3dapps/imgs/尺寸.png"),
iconClick: require("../../../3dapps/imgs/尺寸-选中.png"),
},
],
tabTitle: [
{
title: '花瓶',
enabled: true,
},
{
title: '浮雕',
enabled: true,
},
{
title: '形状',
enabled: true,
},
],
tabTitle1: [
{
title: '设置',
enabled: true,
},
{
title: '位置',
enabled: true,
},
],
tabTitle2: [
{
title: '线条'
},
{
title: '旋转'
},
{
title: '设置'
},
],
tabTitle3: [
{
title: '线条'
},
{
title: '旋转'
},
{
title: '设置'
},
],









rotationsWayList: [
{
key: '1',
title: '默认'
}, {
key: '2',
title: '波浪'
}, {
key: '3',
title: '双波浪'
}
],
bottleDataList1: [{
key: '1',
title: '直线'
}, {
key: '2',
title: '弧线'
}],
bottleDataList2: [{
key: '1',
title: '直线'
}, {
key: '2',
title: '弧线'
}],
choiceStyleList: [{
key: 'circle',
title: '圆形'
}, {
key: 'polygon',
title: '正多边形'
}, {
key: 'curve',
title: '任意多边形'
}],
predefinedCurves: [{
src: img1,
Curves: [
new THREE.Vector2(24, -143.7763310185185),
new THREE.Vector2(-29.60026041666667, -72.33224826388889),
new THREE.Vector2(-52.31105324074074, 4),
new THREE.Vector2(-47.444082754629626, 93.33224826388889),
new THREE.Vector2(28, 137.7763310185185)
],
Curves2: [],
Curves3: [],
neck_curve: "circle",
rotation: 0,
rotationText: 0,
scale: 0.45,
repeatTimes: 4,
edgeIsLine: false,
}, {
src: img2,
Curves: [
new THREE.Vector2(4, -159.7763310185185),
new THREE.Vector2(28.399739583333332, -118.33224826388889),
new THREE.Vector2(-6.3110532407407405, 0),
new THREE.Vector2(-39.444082754629626, 118.33224826388889),
new THREE.Vector2(0, 157.7763310185185)
],
Curves2: [],
Curves3: [],
neck_curve: "circle",
rotation: 0,
rotationText: 0,
scale: 0.45,
repeatTimes: 4,
edgeIsLine: false,
}, {
src: img3,
Curves: [
new THREE.Vector2(-2, -140.7763310185185),
new THREE.Vector2(17.399739583333332, -106.33224826388889),
new THREE.Vector2(-20.31105324074074, -13),
new THREE.Vector2(-51.444082754629626, 96.33224826388889),
new THREE.Vector2(1, 138.7763310185185)
],
Curves2: [],
Curves3: [],
neck_curve: "circle",
rotation: 0,
rotationText: 0,
scale: 0.45,
repeatTimes: 4,
edgeIsLine: false,
}, {
src: img4,
Curves: [
new THREE.Vector2(12, -146.7763310185185),
new THREE.Vector2(-81.60026041666667, -70.33224826388889),
new THREE.Vector2(-8.31105324074074, 3),
new THREE.Vector2(-84.44408275462962, 111.33224826388889),
new THREE.Vector2(5, 138.7763310185185)
],
Curves2: [],
Curves3: [],
neck_curve: "circle",
rotation: 0,
rotationText: 0,
scale: 0.45,
repeatTimes: 4,
edgeIsLine: false,
}, {
src: img5,
Curves: [
new THREE.Vector2(37.5232383060395, -141.7763310185185),
new THREE.Vector2(12.72067131436066, -65.96008643192798),
new THREE.Vector2(-81.24014993655535, -13.415590898179596),
new THREE.Vector2(-74.77481831052455, 105.74479161620816),
new THREE.Vector2(-2.067853818871921, 126.64700185430756)
],
Curves2: [],
Curves3: [],
neck_curve: "circle",
rotation: 0,
rotationText: 0,
scale: 0.45,
repeatTimes: 4,
edgeIsLine: false,
}, {
src: img6,
Curves: [
new THREE.Vector2(24, -143.7763310185185),
new THREE.Vector2(-27.60026041666667, -72.33224826388889),
new THREE.Vector2(-75.31105324074073, 14),
new THREE.Vector2(-29.444082754629626, 84.33224826388889),
new THREE.Vector2(23, 137.7763310185185)
],
Curves2: [],
Curves3: [],
neck_curve: "polygon",
rotation: -3.1,
rotationText: "-180",
scale: 0.45,
repeatTimes: 4,
edgeIsLine: true,
}, {
src: img7,
Curves: [
new THREE.Vector2(35, -149.7763310185185),
new THREE.Vector2(33.39973958333333, -108.33224826388889),
new THREE.Vector2(16.68894675925926, -59),
new THREE.Vector2(-37.908396843086315, 27.27023998517918),
new THREE.Vector2(-41.444082754629626, 52.332248263888886),
new THREE.Vector2(-15.947915739478919, 107.75654478457767),
new THREE.Vector2(9, 154.7763310185185)
],
Curves2: [],
Curves3: [],
neck_curve: "polygon",
rotation: 0,
rotationText: "0",
scale: 0.45,
repeatTimes: 5,
edgeIsLine: true,
}, {
src: img8,
Curves: [
new THREE.Vector2(19, -121.7763310185185),
new THREE.Vector2(17.399739583333332, -106.33224826388889),
new THREE.Vector2(-5.3110532407407405, -69),
new THREE.Vector2(-7.444082754629626, 109.33224826388889),
new THREE.Vector2(13, 137.7763310185185)
],
Curves2: [
new THREE.Vector2(28, -36),
new THREE.Vector2(-3, -29),
new THREE.Vector2(1, 0),
new THREE.Vector2(-3, 29),
new THREE.Vector2(28, 36),
],
Curves3: [],
neck_curve: "polygon",
rotation: -0.1,
rotationText: "-6",
scale: 0.45,
repeatTimes: 4,
edgeIsLine: false,
},
{
src: img9,
Curves: [
new THREE.Vector2(11, -167.7763310185185),
new THREE.Vector2(4.399739583333329, -135.33224826388889),
new THREE.Vector2(-27.628840199223273, -99.69878005981447),
new THREE.Vector2(-34.31105324074074, -26),
new THREE.Vector2(-36.444082754629626, 146.33224826388889),
new THREE.Vector2(-7, 171.7763310185185)
],
Curves2: [],
Curves3: [],
neck_curve: "polygon",
rotation: 0,
rotationText: 0,
scale: 0.45,
repeatTimes: 25,
edgeIsLine: true
}, {
src: img10,
Curves: [
new THREE.Vector2(44, -163.7763310185185),
new THREE.Vector2(42.86231669827248, -132.53706437298655),
new THREE.Vector2(33.39973958333333, -91.33224826388889),
new THREE.Vector2(34.82349407231366, -49.57172727584839),
new THREE.Vector2(11.68894675925926, -5),
new THREE.Vector2(8.555917245370374, 68.33224826388889),
new THREE.Vector2(9, 193.7763310185185)
],
Curves2: [],
Curves3: [],
neck_curve: "circle",
rotation: 0,
rotationText: 0,
scale: 0.45,
repeatTimes: 4,
edgeIsLine: false
}, {
src: img11,
Curves: [
new THREE.Vector2(45, -157.7763310185185),
new THREE.Vector2(41.737261415283555, -124.89456470494657),
new THREE.Vector2(25.399739583333332, -92.33224826388889),
new THREE.Vector2(-24.31105324074074, -37),
new THREE.Vector2(-32.444082754629626, 9.332248263888886),
new THREE.Vector2(-31, 123.7763310185185)
],
Curves2: [],
Curves3: [],
neck_curve: "circle",
rotation: 0,
rotationText: 0,
scale: 0.45,
repeatTimes: 4,
edgeIsLine: false
}, {
src: img12,
Curves: [
new THREE.Vector2(46, -164.7763310185185),
new THREE.Vector2(32.555917245370374, -83.66775173611111),
new THREE.Vector2(8.425057654037037, 27.864057735183778),
new THREE.Vector2(-31, 168.7763310185185)
],
Curves2: [],
Curves3: [],
neck_curve: "circle",
rotation: 0,
rotationText: 0,
scale: 0.45,
repeatTimes: 4,
edgeIsLine: false
}, {
src: img13,
Curves: [
new THREE.Vector2(4, -159.7763310185185),
new THREE.Vector2(28.399739583333332, -118.33224826388889),
new THREE.Vector2(-11.31105324074074, -8),
new THREE.Vector2(8.555917245370374, 98.33224826388889),
new THREE.Vector2(0, 157.7763310185185)
],
Curves2: [
new THREE.Vector2(28, -36),
new THREE.Vector2(-11, -34),
new THREE.Vector2(-12, 0),
new THREE.Vector2(-11, 34),
new THREE.Vector2(28, 36)
],
Curves3: [],
neck_curve: "polygon",
rotation: 0,
rotationText: 0,
scale: 0.45,
repeatTimes: 6,
edgeIsLine: false
}, {
src: img14,
Curves: [
new THREE.Vector2(25, -137.7763310185185),
new THREE.Vector2(39.39973958333333, -111.33224826388889),
new THREE.Vector2(31.68894675925926, -60),
new THREE.Vector2(0.5559172453703738, 83.33224826388889),
new THREE.Vector2(17, 162.7763310185185)
],
Curves2: [
new THREE.Vector2(28, -36),
new THREE.Vector2(-25, -39),
new THREE.Vector2(-4, 0),
new THREE.Vector2(-25, 39),
new THREE.Vector2(28, 36)
],
Curves3: [],
neck_curve: "polygon",
rotation: 0.9,
rotationText: 51,
scale: 0.45,
repeatTimes: 5,
edgeIsLine: false
}, {
src: img15,
Curves: [
new THREE.Vector2(36, -145.7763310185185),
new THREE.Vector2(4.399739583333332, -68.33224826388889),
new THREE.Vector2(-15.31105324074074, 22),
new THREE.Vector2(-12.444082754629626, 88.33224826388889),
new THREE.Vector2(0, 157.7763310185185)
],
Curves2: [],
Curves3: [],
neck_curve: "curve",
rotation: -1.6,
rotationText: -92,
scale: 0.45,
repeatTimes: 4,
edgeIsLine: false
}
],
vaseReliefList: [
{
src: relief1,
},
{
src: relief2,
},
{
src: relief3,
},
{
src: relief4,
},
],
}
},
mounted() {
const scope = this;
scope.showLoading = true;
scope.showVaseBottom = true;


scope.showMenu = true;

var mo = function (e) {
e.preventDefault();
}

initThree(scope.$refs.canvas);
scope.floor = createFloor();


const contentDOM = scope.$refs.papercutLamp;


const resize1 = function (e) {
if (!scope.$refs.canvas) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight;



scope.$refs.canvas.width = w; 
scope.$refs.canvas.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}

scope.init3d(contentDOM, camera, renderer, resize1);



var reliefVase = this.$refs.tabList; 


var screenHeight = window.innerHeight;
window.onresize = function () {
if (screenHeight !== window.innerHeight) {

reliefVase.style.bottom = 0 + "px";
reliefVase.style.position = "absolute";
} else {

reliefVase.style.bottom = 50 + "px";
reliefVase.style.position = "fixed";
}
};
window.addEventListener("resize", onresize);


var interval;


reliefVase.onfocus = function () {
interval = setInterval(function () {
reliefVase.style.bottom = 0 + "px";
reliefVase.style.position = "absolute";
}, 500)
};


reliefVase.onblur = function () {
reliefVase.style.bottom = 50 + "px";
reliefVase.style.position = "fixed";
clearInterval(interval);
};


scope.$nextTick(function () {
scope.$refs.papercutLamp.style.paddingTop = '0px';
scope.$refs.papercutLamp.style.overflow = 'hidden';
scope.$refs.canvasBox.addEventListener("touchmove", mo, false);
})


scope.touchstart();

scope.$nextTick(function () {


scope.loadData();
});
},
watch: {

},
methods: {
updateMesh() {
if (this.noUpdateMesh) return;
this.showLoading = true;
incRenderCount();
},

isShowMenu() {
this.showMenu = !this.showMenu;
},

touchend() {
setTimeout(() => {
this.noUpdateMesh = false;
this.updateMesh();
this.showLoading = false;
console.log("4458585");
}, 1000);
},


loadData() {
const scope = this;
let work = scope.$route.query.work;
try {
if (work) {
scope.$request.post('/SmallSoftware/work', {
work: work
}).then(function (res) {
scope.isShareWork = true;
if (res.obj.owner.avatar === null) {
scope.ownerImg = shareImg;
} else {
scope.ownerImg = res.obj.owner.avatar;
}
scope.ownerName = res.obj.owner.name;
scope.showXiang = false;
console.log("work", res, scope.ownerName, scope.ownerImg);
if (res.obj.data.versionNum === undefined) {

if (res.obj.data.neck_curve) {
scope.choiceStyle = 1;
scope.bottleData = 1;
} else {
scope.choiceStyle = 0;
}
editor.scale = 0.7;
editor.setVaseContent(res.obj.data.vaseContent.map(p => new THREE.Vector2(p.x, p.y)));
editor2.scale = 0.7;
editor2.setVaseContent(res.obj.data.drawCurve.map(p => new THREE.Vector2(p.x, p.y)));
scope.draw.scale = res.obj.data.scale;
scope.draw.rotation = res.obj.data.rotations;
scope.draw.repeatTimes = res.obj.data.repeatTimes;
scope.isShapeIndex = res.obj.data.isShapeIndex;
scope.rotationsWayData = "1";
scope.isReliefIndex = -1;
if (scope.choiceStyle == 0) {
scope.seleNoRelief();
}
} else if (res.obj.data.versionNum === 1) {
editor.setVaseContent(res.obj.data.vaseContent.map(p => new THREE.Vector2(p.x, p.y)));
editor2.setVaseContent(res.obj.data.drawCurve.map(p => new THREE.Vector2(p.x, p.y)));
editor3.controlPoints = res.obj.data.drawCurve2.map(p => new THREE.Vector2(p.x, p.y));
scope.draw.scale = res.obj.data.scale;
scope.draw.rotation = res.obj.data.rotation;
scope.draw.repeatTimes = res.obj.data.repeatTimes;
scope.isShapeIndex = res.obj.data.isShapeIndex;

scope.choiceStyle = res.obj.data.choiceStyle;
scope.bottleData = res.obj.data.bottleData;
scope.irregularData = res.obj.data.irregularData;
scope.pointCount = res.obj.data.vaseContent.length;
scope.pointCount1 = res.obj.data.pointCount1;
scope.pointCount2 = res.obj.data.pointCount2;
scope.rotationsWayData = "1";
scope.isReliefIndex = -1;
if (scope.choiceStyle == 0) {
scope.seleNoRelief();
}
console.log("choiceStyle");

} else if (res.obj.data.versionNum === 2) {
editor.setVaseContent(res.obj.data.vaseContent.map(p => new THREE.Vector2(p.x, p.y)));
editor2.setVaseContent(res.obj.data.drawCurve.map(p => new THREE.Vector2(p.x, p.y)));
editor3.controlPoints = res.obj.data.drawCurve2.map(p => new THREE.Vector2(p.x, p.y));

scope.draw.scale = res.obj.data.scale;
scope.draw.rotation = res.obj.data.rotation;
scope.draw.repeatTimes = res.obj.data.repeatTimes;
scope.draw.bottomPosition = res.obj.data.bottomPosition;
scope.draw.curvePosition = res.obj.data.curvePosition;
scope.draw.stampHeightHalf = res.obj.data.stampHeightHalf;
scope.isShapeIndex = res.obj.data.isShapeIndex;
scope.isReliefIndex = res.obj.data.isReliefIndex;

scope.userUploadImages = res.obj.data.userUploadImages;

scope.choiceStyle = res.obj.data.choiceStyle;
scope.bottleData = res.obj.data.bottleData;
scope.irregularData = res.obj.data.irregularData;
scope.pointCount = res.obj.data.pointCount;
scope.pointCount1 = res.obj.data.pointCount1;
scope.pointCount2 = res.obj.data.pointCount2;
scope.rotationsWayData = res.obj.data.rotationsWayData;
if (scope.choiceStyle == 0) {
scope.showXiang = true;
if (scope.isReliefIndex === -1) {
scope.seleNoRelief();
} else if (scope.isReliefIndex === -3) {
scope.userUploadImageOnOSS = res.obj.data.userUploadImageOnOSS;

scope.noUpdateMesh = false;
scope.showLoading = true;


setTimeout(() => {
stampImage.crossOrigin = "anonymous";
stampImage.onload = function () {
let canvas = document.createElement("canvas");
canvas.width = stampImage.naturalWidth;
canvas.height = stampImage.naturalHeight;
let context = canvas.getContext("2d");
context.drawImage(stampImage, 0, 0, canvas.width, canvas.height);
stampData = context.getImageData(0, 0, canvas.width, canvas.height);
scope.updateMesh();
};
stampImage.src = scope.userUploadImageOnOSS;
scope.showLoading = false;
}, 50);
return;
} else if (scope.isReliefIndex >= 0) {
scope.seleReliefItem(scope.isReliefIndex);
}
}
}
});
return;
}
} catch (err) {
console.log(err.message);
scope.showLoading = false;
return;
}


if (window.localStorage) {
let dataStr = localStorage.getItem("reliefVase");
localStorage.removeItem("reliefVase"); 

if (dataStr) {
scope.showLoading = true;
scope.noUpdateMesh = true;

let data = JSON.parse(dataStr);

scope.draw.scale = data.scale;
scope.draw.rotation = data.rotation;
scope.draw.repeatTimes = data.repeatTimes;
scope.isShapeIndex = data.isShapeIndex;
scope.isReliefIndex = data.isReliefIndex;
scope.userUploadImageOnOSS = data.userUploadImageOnOSS;
scope.draw.bottomPosition = data.bottomPosition;
scope.draw.curvePosition = data.curvePosition;
scope.draw.stampHeightHalf = data.stampHeightHalf;

scope.userUploadImages = data.userUploadImages;
scope.rotationsWayData = data.rotationsWayData;

scope.choiceStyle = data.choiceStyle;
scope.bottleData = data.bottleData;
scope.irregularData = data.irregularData;
scope.pointCount = data.pointCount;
scope.pointCount1 = data.pointCount1;
scope.pointCount2 = data.pointCount2;

scope.versionNum = data.versionNum;


if (data.width1 > 0 && data.height1 > 0) {
editor.loadSize(data.scale1, data.width1, data.height1);
}

if (data.width2 > 0 && data.height2 > 0) {
editor2.loadSize(data.scale2, data.width2, data.height2);
}

editor.setVaseContent(data.vaseContent.map(p => new THREE.Vector2(p.x, p.y)));
editor2.setVaseContent(data.drawCurve.map(p => new THREE.Vector2(p.x, p.y)));
editor3.controlPoints = data.drawCurve2.map(p => new THREE.Vector2(p.x, p.y));

scope.noUpdateMesh = false;

console.log("isReliefIndex", scope.isReliefIndex);

if (scope.isReliefIndex === -1) {
scope.seleNoRelief();
} else if (scope.isReliefIndex === -3) {
console.log("saseewfwefwefwefrew2");
let src = scope.userUploadImageOnOSS;
let stampImage = new Image();
stampImage.crossOrigin = "anonymous";
stampImage.onload = function () {
let canvas = document.createElement("canvas");
canvas.width = stampImage.naturalWidth;
canvas.height = stampImage.naturalHeight;
let context = canvas.getContext("2d");
context.drawImage(stampImage, 0, 0, canvas.width, canvas.height);
stampData = context.getImageData(0, 0, canvas.width, canvas.height);
scope.updateMesh();
};
stampImage.src = src;
} else if (scope.isReliefIndex === -2) {
console.log("saseewfwefwefwefrew");
let imgUid = scope.userUploadImages[0].uid;
let ext = scope.userUploadImages[0].ext;
let src = baseURL + "/SmallSoftware/getImage/" + imgUid + "/" + ext;
let stampImage = new Image();
stampImage.crossOrigin = "anonymous";
stampImage.onload = function () {
let canvas = document.createElement("canvas");
canvas.width = stampImage.naturalWidth;
canvas.height = stampImage.naturalHeight;
let context = canvas.getContext("2d");
context.drawImage(stampImage, 0, 0, canvas.width, canvas.height);
stampData = context.getImageData(0, 0, canvas.width, canvas.height);
scope.updateMesh();
};
stampImage.src = src;
} else if (scope.isReliefIndex >= 0) {
scope.seleReliefItem(scope.isReliefIndex);
}
} else {
scope.seleReliefItem(scope.isReliefIndex);
}
}

},


saveData() {
const scope = this;
if (window.localStorage) {
let data = {};
data.scale = scope.draw.scale;
data.rotation = scope.draw.rotation;
data.repeatTimes = scope.draw.repeatTimes;
data.isShapeIndex = scope.isShapeIndex;
data.isReliefIndex = scope.isReliefIndex;
data.bottomPosition = scope.draw.bottomPosition;
data.curvePosition = scope.draw.curvePosition;
data.stampHeightHalf = scope.draw.stampHeightHalf;
data.userUploadImages = scope.userUploadImages;
data.userUploadImageOnOSS = scope.userUploadImageOnOSS;
data.choiceStyle = scope.choiceStyle;
data.bottleData = scope.bottleData;
data.irregularData = scope.irregularData;
data.pointCount = scope.pointCount;
data.pointCount1 = scope.pointCount1;
data.pointCount2 = scope.pointCount2;
data.drawCurve2 = editor3.getControlPoints();
data.rotationsWayData = scope.rotationsWayData;

data.versionNum = scope.versionNum;

data.vaseContent = editor.getVaseContent();
data.drawCurve = editor2.getVaseContent();
data.scale1 = editor.scale;
data.scale2 = editor2.scale;
data.width1 = editor.width;
data.width2 = editor2.width;
data.height1 = editor.height;
data.height2 = editor2.height;
data.ownerName = scope.ownerName;
data.ownerImg = scope.ownerImg;
localStorage.setItem("reliefVase", JSON.stringify(data));
}
},

handler1(index) {
this.optimizedIndexClick();
this.btnsListIndex1 = index;
let work = this.$route.query.work;
if (work) {
this.showOwner = false;
this.showXiang = false;
}
if (index === 0) {//花瓶
this.showTabList = !this.showTabList;
this.showTabList1 = false;
this.showCurve = false;
this.showBottle = false;
this.showIrregular = false;
this.showDownloads = false;
this.showRelief = false;
this.showBottomPop = false;
this.bottleData = 0;


if (!this.showTabList) {
if (work) {
this.showOwner = true;
}
this.optimizedIndexClick();
this.optimizedBtnClick();
this.showDownloads = false;
this.resize();
return;
}

this.optimizedBtnClick();
this.btnsList1[0].isClick = true;
this.resize();
return;
} else if (index === 1) {//浮雕
this.showTabList1 = !this.showTabList1;
this.showCurve = false;
this.showTabList = false;
this.showBottle = false;
this.showIrregular = false;
this.showDownloads = false;
this.showRelief = false;
this.showBottomPop = false;

this.showVaseScale = true;
this.showVaseBottom = true;
this.showRotationsWay = true;
if (work) {
this.showXiang = false;
} else {
this.showXiang = true;
}

if (this.choiceStyle === 0) {
this.showRepeatTimes = false;
this.showPoints1 = false;
this.showPoints2 = false;
this.showRotations = false;
this.showBottleData = false;
this.showIrregularData = false;

this.showReliefScale = true;
this.showReliefBottom = true;
} else if (this.choiceStyle === 1) {
this.showBottleData = true;
this.showRepeatTimes = true;
this.showPoints1 = true;
this.showPoints2 = false;
this.showRotations = true;
this.showIrregularData = false;
this.showReliefBottom = false;

this.showReliefScale = false;
} else if (this.choiceStyle === 2) {
this.showPoints2 = true;
this.showRotations = true;
this.showIrregularData = true;
this.showRepeatTimes = false;
this.showBottleData = false;
this.showPoints1 = false;
this.showReliefBottom = false;

this.showReliefScale = false;
}

if (!this.showTabList1) {
this.showOwner = true;
this.optimizedIndexClick();
this.optimizedBtnClick();
this.showDownloads = false;
this.resize();
return;
}

this.optimizedBtnClick();
this.btnsList1[1].isClick = true;
this.resize();
return;
} else if (index === 2) {//形状
this.showCurve = !this.showCurve;
this.showTabList1 = false;
this.showTabList = false;
this.showBottle = false;
this.showIrregular = false;
this.showDownloads = false;
this.showRelief = false;
this.showBottomPop = false;

this.$nextTick(function () {
editor.setSize();
editor.draw();
});

if (!this.showCurve) {
if (work) {
this.showOwner = true;
}
this.optimizedIndexClick();
this.optimizedBtnClick();
this.showDownloads = false;
this.resize();
return;
}

this.optimizedBtnClick();
this.btnsList1[2].isClick = true;
this.resize();
return;
}
},

handler2(index) {
this.optimizedIndexClick();
this.btnsListIndex2 = index;
let work = this.$route.query.work;
if (index === 0) {
this.showBottle = !this.showBottle;
this.showTabList1 = false;
this.showCurve = false;
this.showTabList = false;
this.showIrregular = false;
this.showDownloads = false;
this.showRelief = false;

this.$nextTick(function () {
editor2.setSize();
editor2.draw();
});

if (!this.showBottle) {
if (work) {
this.showOwner = true;
}
this.optimizedIndexClick();
this.optimizedBtnClick();
this.showDownloads = false;
this.resize();
return;
}

this.optimizedBtnClick();
this.btnsList2[0].isClick = true;
this.resize();
return;
}
},

handler3(index) {
this.optimizedIndexClick();
this.btnsListIndex3 = index;
let work = this.$route.query.work;
if (index === 0) {
this.showIrregular = !this.showIrregular;
this.showTabList1 = false;
this.showBottle = false;
this.showCurve = false;
this.showTabList = false;
this.showDownloads = false;
this.showRelief = false;

this.$nextTick(function () {
editor3.updateSize();
editor3.updatePoints();
editor3.draw();
});

if (!this.showIrregular) {
if (work) {
this.showOwner = true;
}
this.optimizedIndexClick();
this.optimizedBtnClick();
this.resize();
return;
}

this.optimizedBtnClick();
this.btnsList3[0].isClick = true;
this.resize();
return;
}
},

handler4(index) {
this.optimizedIndexClick();
this.btnsListIndex4 = index;
if (index === 0) {
this.showRelief = !this.showRelief;
this.showTabList1 = false;
this.showCurve = false;
this.showTabList = false;
this.showBottle = false;
this.showIrregular = false;
this.showDownloads = false;

this.showVaseScale = true;
this.showVaseBottom = true;

if (!this.showRelief) {
this.optimizedIndexClick();
this.optimizedBtnClick();
this.showDownloads = false;
this.resize();
return;
}

this.optimizedBtnClick();
this.btnsList4[0].isClick = true;
this.resize();
return;
}
},

optimizedBtnClick() {
this.btnsList1[0].isClick = false;
this.btnsList1[1].isClick = false;
this.btnsList1[2].isClick = false;
this.btnsList4[0].isClick = false;
this.btnsList2[0].isClick = false;
this.btnsList3[0].isClick = false;
},

optimizedIndexClick() {
this.btnsListIndex1 = -1;
this.btnsListIndex2 = -1;
this.btnsListIndex3 = -1;
this.btnsListIndex4 = -1;
},

optimizedPopClick() {
this.showPrint = false;
this.showTabList = false;
this.showTabList1 = false;
this.showCurve = false;
this.showBottle = false;
this.showIrregular = false;
this.showDownloads = false;
this.showRelief = false;
this.showBottomPop = false;

this.showPotImg = true;
this.showPrintImg = true;
this.showdownloadImg = true;
this.showShareImg = true;

this.showXiang = false;
if (this.choiceStyle == 0 && this.isReliefIndex != -1) {

this.showXiang = true;
}
},


isClickPot() {
this.isTopBtn();

this.$refs.btn_import.click();
},

onFileChange1(e) {
let file = e.target.files[0];
if (!file) {
return;
};


let formData = new FormData();
formData.append("img", file);
this.$request.post("/SmallSoftware/addImage", formData, {
headers: {
'Content-Type': 'multipart/form-data'
}
}).then(res => {
console.log(res);
this.userUploadImages.unshift({
uid: res.obj.img_uid,
ext: res.obj.ext
});
let url = URL.createObjectURL(file);


console.log("urel", this.userUploadImages);

this.isReliefIndex = -2;

const scope = this;
scope.showLoading = true;
let stampImage = new Image();
stampImage.crossOrigin = "anonymous";
setTimeout(() => {
stampImage.onload = function () {
let canvas = document.createElement("canvas");
canvas.width = stampImage.naturalWidth;
canvas.height = stampImage.naturalHeight;
let context = canvas.getContext("2d");
context.drawImage(stampImage, 0, 0, canvas.width, canvas.height);
stampData = context.getImageData(0, 0, canvas.width, canvas.height);
scope.updateMesh();
scope.showLoading = false;
};
stampImage.src = url;
}, 50);
})
},


touchstart() {
this.isTopBtn();
this.resize();
},

isTopBtn() {
this.optimizedPopClick();
this.optimizedBtnClick();
this.resize();
this.optimizedIndexClick();
},


seleVaseItem(index) {
this.showLoading = true;
this.isShapeIndex = index;
setTimeout(() => {
let vaseData = this.predefinedCurves[index];
console.log("vaseData", vaseData, editor.scale);
editor.setVaseContent(vaseData.Curves);
this.draw.rotation = THREE.Math.radToDeg(vaseData.rotation);
this.draw.repeatTimes = vaseData.repeatTimes;
this.draw.scale = vaseData.scale;
this.choiceStyle = this.choiceStyleList.findIndex(item => item.key === vaseData.neck_curve);
if (this.choiceStyle === 1) {
this.bottleData = vaseData.edgeIsLine ? 0 : 1;
if (!vaseData.edgeIsLine) {
editor2.setVaseContent(vaseData.Curves2);
}
} else if (this.choiceStyle === 2) {
this.irregularData = vaseData.edgeIsLine;

} else if (this.choiceStyle === 3) {
this.irregularData = vaseData.isLine;
}

this.noUpdateMesh = false;
this.updateMesh();
this.showLoading = false;
}, 50);
},

seleNoRelief() {
const scope = this;
scope.showLoading = true;
scope.isReliefIndex = -1;
scope.tabTitle1[0].enabled = false;
scope.tabTitle1[1].enabled = true;
scope.showReliefScale = false;
scope.showReliefBottom = false;
scope.showXiang = false;


scope.choiceStyle = 0
scope.cur1 = 1;
scope.showVaseScale = true;
scope.showVaseBottom = true;
setTimeout(() => {
stampData = null;
scope.noUpdateMesh = false;
scope.updateMesh();
scope.showLoading = false;
}, 50);
},


seleReliefItem(index) {
const scope = this;
scope.showLoading = true;
scope.isReliefIndex = index;
scope.tabTitle1[0].enabled = true;
scope.tabTitle1[1].enabled = true;
scope.cur1 = 0;
scope.showXiang = true;
setTimeout(() => {
scope.$nextTick(function () {
stampImage.onload = function () {
let canvas = document.createElement("canvas");
canvas.width = stampImage.naturalWidth;
canvas.height = stampImage.naturalHeight;
let context = canvas.getContext("2d");
context.drawImage(stampImage, 0, 0, canvas.width, canvas.height);
stampData = context.getImageData(0, 0, canvas.width, canvas.height);
scope.updateMesh();
};
stampImage.src = scope.vaseReliefList[scope.isReliefIndex].src;
});
scope.showLoading = false;
}, 50);
console.log("seleReliefItem", stampImage.src, scope.vaseReliefList[scope.isReliefIndex].src);
},


resize() {
let w = document.documentElement.clientWidth;
let h = document.documentElement.clientHeight;
if (this.btnsListIndex1 == 0 || this.btnsListIndex1 == 1) {
let tabHeight = h * 0.2;
h = h - tabHeight;
}
camera.aspect = w / h;
camera.updateProjectionMatrix();
renderer.setSize(w, h);
incRenderCount();
},

closeCurvePop() {
this.isTopBtn();
},




pointReduce() {
if (this.pointCount <= 5) {
this.$vux.toast.show({
type: 'warn',
text: '点的数量不能少5'
});
} else {
this.pointCount--;
editor.redControlPoint();
editor.draw();
}
},
pointAdd() {
this.pointCount++;
editor.incControlPoint();
},

pointReduce1() {
if (this.pointCount1 <= 5) {
this.$vux.toast.show({
type: 'warn',
text: '点的数量不能少5'
});
} else {
this.pointCount1--;
editor2.redControlPoint();
editor2.draw();
}
},
pointAdd1() {
this.pointCount1++;
editor2.incControlPoint();
},

pointReduce2() {
if (this.pointCount2 <= 4) {
this.$vux.toast.show({
type: 'warn',
text: '点的数量不能少4'
});
} else {
this.pointCount2--;
editor3.redControlPoint();
editor3.updatePoints();
editor3.draw();
}
},
pointAdd2() {
this.pointCount2++;
editor3.incControlPoint();
editor3.updatePoints();
editor3.draw();
},

copy(str) {
var save = function (e) {
e.clipboardData.setData('text/plain', str);
e.preventDefault();
}
document.addEventListener('copy', save);
document.execCommand('copy');
document.removeEventListener('copy', save);
},


share() {
const scope = this;
scope.isTopBtn();
scope.showShareImg = !scope.showShareImg;
setTimeout(() => {
scope.showShareImg = false;
}, 1000);



if (!this.$common.getCookie('_token')) {

scope.saveData();

this.$router.push({
path: '/login',
query: {
fullPath: this.$route.fullPath
}
});
scope.showLoading = false;
} else {
this.$nextTick(function () {
let data = {};
data.choiceStyle = scope.choiceStyle;
data.scale = scope.draw.scale;
data.rotation = scope.draw.rotation;
data.repeatTimes = scope.draw.repeatTimes;
data.isShapeIndex = scope.isShapeIndex;
data.bottomPosition = scope.draw.bottomPosition;
data.curvePosition = scope.draw.curvePosition;
data.stampHeightHalf = scope.draw.stampHeightHalf;

data.userUploadImages = scope.userUploadImages;
data.isReliefIndex = scope.isReliefIndex;
data.vaseContent = editor.getVaseContent();
data.drawCurve = editor2.getVaseContent();
data.drawCurve2 = editor3.getControlPoints();
data.scale1 = editor.scale;
data.scale2 = editor2.scale;
data.width1 = editor.width || 0;
data.width2 = editor2.width || 0;
data.height1 = editor.height || 0;
data.height2 = editor2.height || 0;

data.bottleData = scope.bottleData;
data.irregularData = scope.irregularData;
data.pointCount1 = scope.pointCount1;
data.pointCount2 = scope.pointCount2;
data.versionNum = scope.versionNum;
data.rotationsWayData = scope.rotationsWayData;

if (scope.isReliefIndex === -2) { // 是用户自己上传的图片：需要保存到oss中
scope.$request.post("/SmallSoftware/putImageToOSS", {
img_uid: scope.userUploadImages[0].uid,
ext: scope.userUploadImages[0].ext
}).then(res => {
data.isReliefIndex = -3;
data.userUploadImageOnOSS = res.obj;
scope.$request.post('/SmallSoftware/share', {
type: "vase",
data: JSON.stringify(data)
}).then(function (res) {

scope.$vux.toast.show({
type: 'success',
text: '复制成功，去粘贴分享给微信好友吧'
});
let index = location.href.indexOf("?");
let url;
if (index >= 0) {
url = location.href.substr(0, index);
} else {
url = location.href;
}
scope.copy(url + "?work=" + res.obj);
console.log("url", url);
}).catch(function () {
scope.$vux.toast.show({
type: 'warn',
text: '分享失败'
});
});
}).catch(err => {
scope.$vux.toast.show({
type: 'warn',
text: '保存图片失败'
});
});
} else {
scope.$request.post('/SmallSoftware/share', {
type: "vase",
data: JSON.stringify(data)
}).then(function (res) {

scope.$vux.toast.show({
type: 'success',
text: '复制成功，去粘贴分享给微信好友吧'
});
let index = location.href.indexOf("?");
let url;
if (index >= 0) {
url = location.href.substr(0, index);
} else {
url = location.href;
}
scope.copy(url + "?work=" + res.obj);
console.log("url", url);
}).catch(function () {
scope.$vux.toast.show({
type: 'warn',
text: '分享失败'
});
});
}
});
}

scope.noUpdateMesh = false;
scope.updateMesh();
scope.showLoading = false;

},


downloadsBtn() {
this.isTopBtn();
this.showDownloads = !this.showDownloads;
this.showdownloadImg = !this.showdownloadImg;
},


downloads() {
const scope = this;
scope.showDownloads = false;
scope.showLoading = true;



if (!this.$common.getCookie('_token')) {

scope.saveData();

this.$router.push({
path: '/login',
query: {
fullPath: this.$route.fullPath
}
});
scope.showLoading = false;
} else {
scope.$request.post('/SmallSoftware/requestDownload', {
type: "vase",
}).then(function (res) {
console.log("res", res);
if (res.obj === true) {
scope.downloadModels();
setTimeout(() => {
scope.$vux.toast.show({
text: '下载成功',
type: "success",
time: 2000,
position: "middle",
});
scope.isTopBtn();
scope.showLoading = false;
}, 50);
} else {
scope.$vux.toast.show({
text: '下载失败',
type: "warn",
time: 2000,
position: "middle",
});
}
});
}

},
















getModelToPrint() {
console.log("vaseMaker.mesh");

},














closePrint() {
this.isTopBtn();
},

getUploadUrl() {
if (this.choiceStyle == 0 && this.isReliefIndex != -1) {//圆形并且有浮雕
return "/makeVase/makeModel";
} else {//正多边形和任意多边形
return "/SmallSoftware/uploadFile";
}
},


print() {
this.modelSplit = true;
this.isTopBtn();
this.showLoading = true;
this.showPrintImg = !this.showPrintImg;



if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showStyle = false;
this.showlowpriceHeight = true;
}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showStyle = true;
this.showlowpriceHeight = false;
}



















this.saveData();
this.$nextTick(function () {
this.showPrint = true;
this.makeModelForPrint();
this.getPrice();
});

setTimeout(() => {
this.showLoading = false;
}, 50);

this.$vux.toast.show({
text: '3D浮雕不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.noUpdateMesh = false;
this.updateMesh();

setTimeout(() => {
this.showLoading = false;
}, 50);

},
},
}



// WEBPACK FOOTER //
// ./src/views/papercutLamp/scripts/papercutLamp.js